import type { Cell } from './Cell'
import { type Disabled, useDisabledList } from './Disabled'
import { type Period, usePeriodList } from './Period'
import { useTimeZone } from '@sub/utils/times';

function getCellEnd(cell: Cell | Date): Date {
	return cell instanceof Date ? cell : cell.to;
}

function isBeforeDeadLine(cellOrDate: Cell | Date, timezone?: string, shift = 0) {
	const now = timezone ? useTimeZone(new Date(), timezone) : new Date();
	const deadline = new Date(+now + shift);
	return getCellEnd(cellOrDate) <= deadline;
}

export class Calendar {
	#disabledList!: ReturnType<typeof useDisabledList<Disabled[]>>
	timezone
	deadLineAdd = 0
	#periodList!: ReturnType<typeof usePeriodList>

	constructor({
		disabled = [],
		periods = [],
		timezone,
		timeOffset = 0,
		deadLineAdd = 0,
	}: {
		disabled?: Disabled[]
		periods?: Period[]
		timezone?: string
		timeOffset?: number
		deadLineAdd?: number
	}) {
		this.timezone = timezone
		this.deadLineAdd = deadLineAdd
		this.setDisabled(disabled)
		this.#periodList = usePeriodList(periods, timeOffset)
	}

	setDisabled(disabled?: Disabled[]) {
		this.#disabledList = useDisabledList(disabled)
	}

	/** Вроде как, проверка на полное вхождение от начала */
	getAvailableSubset(cell: Cell): Cell {
		const { error: periodDisabled, periodEnd } = this.#periodList.checkPeriod(cell)
		if (periodDisabled && periodEnd) return { from: cell.from, to: periodEnd };

		const { item: disabledListItem } = this.#disabledList.checkOnDisabled(cell)
		if (disabledListItem?.from) return { from: cell.from, to: disabledListItem.from };

		return cell;
	}

	isCellDisabled(cellOrDate: Cell) {
		const deadLine = isBeforeDeadLine(cellOrDate, this.timezone, this.deadLineAdd)

		const { findInDisabledList, result: disabledList } = this.#disabledList.checkOnDisabled(cellOrDate)

		return {
			disabled: deadLine || disabledList || this.#periodList.checkPeriod(cellOrDate).error,
			findInDisabledList,
		}
	}
}
